<template>
  <div id="app">
    <keep-alive>
      <component :is="layout"></component>
    </keep-alive>
  </div>
</template>

<script>
import { bootstrapApp } from '@motionelements/core/src/services/app.service';
import windowResizeMixin from '@motionelements/core/src/components/mixins/window-resize.mixin.js';
import productEventsMixin from '@motionelements/core/src/components/mixins/product-events.mixin.js';

export default {
  name: 'App',
  mixins: [windowResizeMixin, productEventsMixin],
  computed: {
    layout() {
      return () => ({
        component: import('@/layouts/DefaultLayout.vue'),
      });
    },
  },

  beforeCreate() {
    bootstrapApp(this);
  },
};
</script>

<style lang="scss">
  // DISABLED BUTTONS
  .btn.disabled, .btn:disabled {
    cursor: not-allowed !important;
  }

  .b-tooltip {
    opacity: 1 !important;
  }
</style>
